import axiosClient from './axiosClient';
export default {
  list: (params) => axiosClient.get('/studi', { params }),
  get: (id) => axiosClient.get(`/studi/${id}`),
  create: (data) => axiosClient.post('/studi', data),
  update: (id, data) => axiosClient.put(`/studi/${id}`, data),
  delete: (id) => axiosClient.delete(`/studi/${id}`),
  associaContribuenti: (studioId, contribuentiIds) =>
      axiosClient.post(`/studi/${studioId}/associa-contribuenti`,contribuentiIds),
};